import React from "react";
import {  Grid } from "@material-ui/core";
import { mechanicalWorkTaskStyle } from "features/mechanicalWork/mechanicalWorkTaskStyle";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import CardHeader from "features/mechanicalWork/cardHeader";
import { IconSquareMoney } from "icons";

const PricingDetails = ({ activity }) => {
    const classes = mechanicalWorkTaskStyle();
    return (
        <>
            <CardHeader title='Pricing' icon={<IconSquareMoney />} />

            <Grid container spacing={2} className={classes.details}>
                <Authorize profile={permissionProfiles.DASHBOARD.WORKORDER_CLIENT_FILTER}>
                    <Grid item className={classes.detail}>
                        <Grid className={classes.detailLabel}>
                            Activity Cost:
                        </Grid>
                        <Grid >
                            {activity?.price ? `$${activity.price}` : "$0"}
                        </Grid>
                    </Grid>
                </Authorize>

                <Grid item className={classes.detail}>
                    <Grid >
                        <Grid className={classes.detailLabel}>
                            Activity Charge:
                        </Grid>
                        <Grid>
                            {activity?.revenue ? `$${activity.revenue}` : "$0"}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>)
}

export default PricingDetails;